import React, { useLayoutEffect, useEffect, useContext, useRef, useState, useMemo} from 'react';
import classNames from 'classnames';

import AppContext from '../hooks/AppContext'
import ScroolHook from '../hooks/ScroolHook';

import CandidatoDetalhe from './CandidatoDetalhe'
import Aguardando from './Aguardando'

const ListaCandidatos = (props) => {

  const {totalizacao, fotos, rolagemAuto, localidadeSelecionada, cargoSelecionado} = useContext(AppContext);   
  
  const [skeletonShow, setSkeletonShow] = useState(false)

  const [listaCandidatos, setListaCandidatos] = useState(totalizacao?.votosCandidatos)   

  useEffect(() => { 
    //ordena lista de candidatos por voto
    if(props?.ordenaPorVoto && totalizacao){
      setListaCandidatos([...totalizacao?.votosCandidatos]?.sort((a,b) => b.votos - a.votos))
    }else{    
      setListaCandidatos(totalizacao?.votosCandidatos)
    }

    //se totalização encontrada desabilita skeleton
    if(totalizacao){
      setSkeletonShow(false);
    }
    //se totalização retornou nula do firbase desabilita o skeleton
    if(totalizacao===null){
      setTimeout(()=> setSkeletonShow(false),100);
    }

  }, [totalizacao,props?.ordenaPorVoto]);

  
  useEffect(() => { 

    if(localidadeSelecionada && cargoSelecionado && totalizacao!==null){
      setSkeletonShow(true);
    }
    //timeout do skeleton caso não tenha resposta do firebase
    setTimeout(()=> setSkeletonShow(false), 5000);
  }, [localidadeSelecionada, cargoSelecionado]);

  const renderCandidatos = () =>{
    return( 
      listaCandidatos?.map((candidato, index) => {            
        return (<CandidatoDetalhe key={index} foto={fotos.find( item => Number(item?.idCandidato)===Number(candidato?.codigo))?.data} 
          numeroCand={candidato?.numero} nomeCand={candidato?.nome} 
          partido={candidato?.partido?.sigla} situacao={candidato?.situacao} votos={candidato?.votos}/>
        )}
      )
    );
  }

  const renderSkeletons = (num) =>{    
    return( 
      Array.from({length: num}, (v, i) => i).map(item =>{                  
        return <CandidatoDetalhe key={item} skeleton/>
      })
    );
  }

  const wrapperContainer = classNames("container-dado",{
    "bloco-dados align-content-center": !totalizacao && !skeletonShow
  })

  return (   
      <div className={wrapperContainer}>                      
          {
            !totalizacao?
              localidadeSelecionada && cargoSelecionado?
                skeletonShow? 
                  <div className="container-dado flex flex-wrap gap-vhw h-full align-content-start scroolable">               
                    {renderSkeletons(5)}
                  </div>
                :
                  <Aguardando/>
              :
                <div className="container-dado-alt">Selecione uma Localidade e Cargo para carregar os dados da votação</div>

            :
              <ScroolHook listaDados={listaCandidatos} className="candidatos-container">
                {renderCandidatos()}
              </ScroolHook>                                            
          }            
      </div>        
  );
}

export default ListaCandidatos;
